import { useCallback, useEffect, useState } from "react";
import { apiUrl } from "../ApiManager/AxiosHeaders";
import {
  COMPANY_FORM_GLOBAL_DESTINATION,
  DEFAULT_COMPANY_FORM_DESTINATIONS,
} from "./companyFormConstants";

function parseDestinationPayload(raw) {
  if (Array.isArray(raw)) {
    return raw.map(String).map((s) => s.trim()).filter(Boolean);
  }
  if (raw && typeof raw === "object") {
    return Object.values(raw)
      .map(String)
      .map((s) => s.trim())
      .filter(Boolean);
  }
  return [];
}

/** Keep Global first; union API list with defaults so filters stay complete if API is partial. */
function buildDestinationList(apiRows) {
  const global = COMPANY_FORM_GLOBAL_DESTINATION;
  const seen = new Set();
  const merged = [];

  const add = (value) => {
    const label = String(value || "").trim();
    if (!label || seen.has(label)) return;
    seen.add(label);
    merged.push(label);
  };

  add(global);
  DEFAULT_COMPANY_FORM_DESTINATIONS.forEach(add);
  apiRows.forEach(add);

  return merged;
}

export function useCompanyFormDestinations() {
  const [destinations, setDestinations] = useState(DEFAULT_COMPANY_FORM_DESTINATIONS);
  const [globalDestination, setGlobalDestination] = useState(COMPANY_FORM_GLOBAL_DESTINATION);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const response = await apiUrl.get("/company-forms/destinations");
      const apiRows = parseDestinationPayload(response?.data?.data);
      setDestinations(
        apiRows.length > 0 ? buildDestinationList(apiRows) : DEFAULT_COMPANY_FORM_DESTINATIONS,
      );

      const global = response?.data?.global;
      if (global) {
        setGlobalDestination(String(global).trim() || COMPANY_FORM_GLOBAL_DESTINATION);
      }
    } catch {
      setDestinations(DEFAULT_COMPANY_FORM_DESTINATIONS);
      setGlobalDestination(COMPANY_FORM_GLOBAL_DESTINATION);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return {
    destinations,
    globalDestination,
    destinationsLoading: loading,
    refreshDestinations: refresh,
  };
}
